module.exports = (parcelRequire.load("50t6p")).then(() => parcelRequire('aOyad'));